// extracted by mini-css-extract-plugin
module.exports = {"signup":"Security_signup__11zsx","container":"Security_container__30-LU","signupButton":"Security_signupButton__tvt2x"};